module.exports = "https://portperrypedals.ca/_res/img/cct.8208e09.png";